import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { getConfig } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [cfg, setCfg] = useState({ whatsapp: "", phone: "", email: "" });

  useEffect(() => {
    getConfig().then(setCfg).catch(() => {});
  }, []);

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copiado al portapapeles");
  };

  const wa = (cfg.whatsapp || "").replace(/\D/g, "");
  const waUrl = wa ? `https://wa.me/${wa}` : "#";

  return (
    <AppShell title="Contacto">
      <div className="px-5 pb-6 stagger" data-testid="contact-info">
        <p className="text-sm text-slate-600 -mt-1">
          Estamos aquí para ayudarte a hacer crecer tu negocio.
        </p>

        <div className="mt-5 space-y-2.5">
          <ContactRow
            icon={<Phone className="w-4 h-4 text-slate-700" />}
            label="Teléfono"
            value={cfg.phone}
            href={`tel:${(cfg.phone || "").replace(/\s/g, "")}`}
            onCopy={() => copy(cfg.phone)}
            testid="row-phone"
          />
          <ContactRow
            icon={<Mail className="w-4 h-4 text-slate-700" />}
            label="Correo"
            value={cfg.email}
            href={`mailto:${cfg.email}`}
            onCopy={() => copy(cfg.email)}
            testid="row-email"
          />
          <ContactRow
            icon={<MessageCircle className="w-4 h-4 text-slate-700" />}
            label="WhatsApp"
            value={cfg.whatsapp}
            href={waUrl}
            external
            onCopy={() => copy(cfg.whatsapp)}
            testid="row-whatsapp"
          />
          <div className="rounded-2xl border border-slate-200 px-4 py-3.5 flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-slate-100 flex items-center justify-center">
              <MapPin className="w-4 h-4 text-slate-700" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.15em] text-slate-500">Ubicación</div>
              <div className="font-medium text-slate-900">Madrid, España</div>
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
}

const ContactRow = ({ icon, label, value, href, external, onCopy, testid }) => (
  <div
    className="rounded-2xl border border-slate-200 px-4 py-3.5 flex items-center gap-3"
    data-testid={testid}
  >
    <div className="h-10 w-10 rounded-xl bg-slate-100 flex items-center justify-center shrink-0">
      {icon}
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-xs uppercase tracking-[0.15em] text-slate-500">{label}</div>
      <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        className="font-medium text-slate-900 truncate block"
      >
        {value || "—"}
      </a>
    </div>
    {value && (
      <button
        onClick={onCopy}
        className="text-xs font-semibold text-[var(--el-red)] px-2 py-1 rounded-md hover:bg-[var(--el-red)]/10"
        data-testid={`${testid}-copy`}
      >
        Copiar
      </button>
    )}
  </div>
);
